import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resources as roleBasedNotificationsResources } from '@atlassian/eoc-role-based-notifications/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { roleBasedNotificationDetailRoute } from '@jira/router-routes__eoc-role-based-notifications-routes/src/roleBasedNotificationDetailRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	LazyRoleBasedNotifications,
	RoleBasedNotificationsComponent,
} from './ui/RoleBasedNotificationsComponent.tsx';
import { RoleBasedNotificationDetail } from './ui/RoleBasedNotificationDetail.tsx';

export const roleBasedNotificationDetailRouteEntry: Route = createEntry(
	roleBasedNotificationDetailRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: RoleBasedNotificationsComponent,
		layout: globalSettingsLayout,
		slot: RoleBasedNotificationDetail,

		resources: [
			...getNavigationResources(),
			roleBasedNotificationsResources[0],
			roleBasedNotificationsResources[1],
			getConsolidationStateResource(),
			navigationSidebarGlobalResource,
		],

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyRoleBasedNotifications],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
